module.exports = __webpack_public_path__ + "img/img20.3c23d7eb.svg";